module.exports = __webpack_public_path__ + "img/list.38c16d59.svg";